// React i hooks
import { NavLink } from "react-router-dom";
import { memo } from "react";

// Helpers
import { classNames } from "helpers";

// Tipovi i konstante
import { TabMenuProps } from "./types";

const TabMenu: React.FC<TabMenuProps> = () => {
  return (
    <>
      <div className="flex border-b border-slate-200 bg-white">
        <NavLink
          to="/account"
          className={({ isActive }: { isActive: boolean }) =>
            classNames(
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600",
              "font-semibold  px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
            )
          }
        >
          Osnovni podaci
        </NavLink>
      </div>
    </>
  );
};

export default memo(TabMenu);
